import Utils from '@/ecm/common/Utils';
export default class NewsfeedSettings {
    constructor(dto) {
        this.id = 0;
        this.description = '';
        this.backgroundColor = '#FFFFFF';
        this.textColor = '#000000';
        this.startDate = Utils.date.now();
        this.startTime = '00:00';
        this.endDate = null;
        this.endTime = null;
        this.target = null;
        this.targetValue = [];
        this.message = null;
        this.user = '';

        if (dto) {
            this.id = dto.Id;
            this.description = dto.Cells.find((c) => c.ColumnName == 'description').Value;
            this.user = dto.Cells.find((c) => c.ColumnName == 'userName').Value;
            this.backgroundColor = dto.Cells.find((c) => c.ColumnName == 'backgroundColor').Value;
            this.textColor = dto.Cells.find((c) => c.ColumnName == 'textColor').Value;
            this.startDate = dto.Cells.find((c) => c.ColumnName == 'startDate').Value;
            this.startTime = dto.Cells.find((c) => c.ColumnName == 'startTime').Value;
            this.endDate = dto.Cells.find((c) => c.ColumnName == 'endDate').Value;
            this.endTime = dto.Cells.find((c) => c.ColumnName == 'endTime').Value;
            this.target = dto.Cells.find((c) => c.ColumnName == 'target').Value;
            this.targetValue = dto.Cells.find((c) => c.ColumnName == 'targetValue').Value;
            this.message = dto.Cells.find((c) => c.ColumnName == 'message').Value;

            if (this.target != '1') {
                this.targetValue = JSON.parse(this.targetValue);
            }
        }
    }

    toDto() {

    }
}
